<!-- FullPageDemo.vue -->
<template>
  <div class="container" ref="containerRef">
    <!-- 第一段：正常滚动 -->
    <section class="normal-section-1">正常内容区（第1段）</section>

    <!-- 第二段：模拟全屏切换 -->
    <!-- 第二段：UI 更新后的全屏切换部分 -->
    <section ref="fullpageRef" class="fullpage-section complex">
      <div class="content-wrapper">
        <!-- 左侧导航 -->
        <div class="left-nav">
          <div
            v-for="(item, index) in fullpages"
            :key="index"
            :class="['nav-item', { active: currentPage === index }]"
          >
            {{ item.title }}
            <span v-if="item.status === 'recruiting'" class="tag"
              >Recruiting in progress</span
            >
          </div>
        </div>

        <!-- 中间图标链 -->
        <div class="middle-icons">
          <div
            v-for="(item, index) in fullpages"
            :key="index"
            :class="['icon-wrapper', { active: currentPage === index }]"
          >
            <img :src="item.icon" class="icon" />
          </div>
        </div>

        <!-- 右侧详细内容 -->
        <div class="right-content">
          <h2>{{ fullpages[currentPage].title }}</h2>
          <p>{{ fullpages[currentPage].desc }}</p>
        </div>
      </div>
    </section>

    <!-- 第三段：正常滚动 -->
    <section class="normal-section">后续正常内容（第3段）</section>
  </div>
</template>
  
  <script setup>
import { onMounted, onBeforeUnmount, ref } from "vue";

const fullpages = [
  {
    title: "Engineering & Equipment",
    desc: "Our Engineering & Equipment arm specializes in comprehensive engineering services for Dairy, Food & Beverage, and Chemical industries at present time...",
    icon: "/icons/engineering.svg", // 替换为你自己的路径
  },
  {
    title: "Logistics Supply Chain Management",
    desc: "We offer end-to-end logistics and supply chain services tailored to various industries...",
    icon: "/icons/logistics.svg",
  },
  {
    title: "Sourcing & Procurement",
    desc: "Our sourcing team connects businesses with reliable suppliers worldwide...",
    icon: "/icons/procurement.svg",
    status: "recruiting", // 控制“Recruiting in progress”标签显示
  },
  {
    title: "Sales & Service Representation",
    desc: "We act as local representatives to help brands expand into new markets efficiently...",
    icon: "/icons/sales.svg",
  },
];

const fullpageRef = ref(null);
const containerRef = ref(null);
const currentPage = ref(0);
const isScrolling = ref(false);

function scrollToPage(index) {
  const el = fullpageRef.value?.children?.[index];
  if (!el) return;

  el.scrollIntoView({ behavior: "smooth" });
  isScrolling.value = true;
  setTimeout(() => {
    isScrolling.value = false;
  }, 700);
}

function isInFullpageView() {
  const fullpageTop = fullpageRef.value.getBoundingClientRect().top;
  const viewportHeight = window.innerHeight;
  // 判断 fullpage 区域是否在视口中（用于判断是否启用拦截）
  return (
    fullpageTop < viewportHeight &&
    fullpageTop > -viewportHeight * (fullpages.length - 1)
  );
}

function handleGlobalWheel(e) {
  if (!isInFullpageView()) return;

  const delta = e.deltaY;

  // 允许滑出 fullpage 区域
  if (
    (currentPage.value === 0 && delta < 0) ||
    (currentPage.value === fullpages.length - 1 && delta > 0)
  ) {
    return; // 放行，不阻止默认滚动
  }

  e.preventDefault(); // 阻止默认滚动
  if (isScrolling.value) return;

  if (delta > 0 && currentPage.value < fullpages.length - 1) {
    currentPage.value++;
    scrollToPage(currentPage.value);
  } else if (delta < 0 && currentPage.value > 0) {
    currentPage.value--;
    scrollToPage(currentPage.value);
  }
}

onMounted(() => {
  window.addEventListener("wheel", handleGlobalWheel, { passive: false });
});

onBeforeUnmount(() => {
  window.removeEventListener("wheel", handleGlobalWheel);
});
</script>
  
  <style scoped>
.container {
  scroll-behavior: smooth;
}

/* 第一段 & 第三段 */
.normal-section {
  height: 100vh;
  background: #f0f0f0;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}
.normal-section-1 {
  height: 70vh;
  background: #f0f0f0;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

/* 模拟全屏区域 */
.fullpage-section {
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  background: #cceeff;
  scroll-snap-align: start;
  transition: all 0.6s;
}
.fullpage-section.complex {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f5faff;
  overflow: hidden;
}

.content-wrapper {
  display: flex;
  width: 100%;
  max-width: 1200px;
  height: 80%;
}

.left-nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.2rem;
  padding-left: 2rem;
}

.nav-item {
  font-size: 1.2rem;
  color: #888;
  position: relative;
}

.nav-item.active {
  color: #001a72;
  font-weight: bold;
}

.nav-item .tag {
  background: #ffa500;
  color: #000;
  font-size: 0.75rem;
  padding: 2px 6px;
  border-radius: 6px;
  margin-left: 0.5rem;
}

.middle-icons {
  flex: 0 0 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  justify-content: center;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  border: 2px solid #ccc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}

.icon-wrapper.active {
  border-color: #001a72;
  background: #e6f0ff;
}

.icon {
  width: 30px;
  height: 30px;
}

.right-content {
  flex: 3;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.right-content h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #001a72;
}

.right-content p {
  font-size: 1.1rem;
  color: #333;
  line-height: 1.6;
}
</style>
  